import proposalSettingsSchema from '../proposalSettings/proposalSettingsSchema';

// Version 1 is the read-only list schema shipped to production (shared dbVersion).
// Version 2 adds the form fields; see proformaInvoiceMigrationStrategies.
// Version 3 adds the server review mark (LAE-752).
// Version 4 adds the payment totals and the paid status source (LAE-768).
export const PROFORMA_INVOICE_SCHEMA_VERSION = 4;

export default {
  title: 'proforma invoice schema',
  version: PROFORMA_INVOICE_SCHEMA_VERSION,
  keyCompression: true,
  primaryKey: 'uuid',
  type: 'object',
  required: ['uuid', 'workspaceId', 'status'],
  properties: {
    uuid: {
      type: 'string',
      maxLength: 100,
    },
    workspaceId: {
      type: 'string',
      maxLength: 36,
    },
    invoiceId: {
      type: ['string', 'null'],
    },
    priceProposalId: {
      type: ['string', 'null'],
      maxLength: 100,
    },
    number: {
      type: ['number', 'null'],
    },
    priceProposalReference: {
      type: ['string', 'null'],
    },
    contactName: {
      type: ['string', 'null'],
    },
    contactId: {
      type: 'string',
      maxLength: 100,
    },
    title: {
      type: ['string', 'null'],
    },
    subtotalPrice: {
      type: ['number', 'null'],
    },
    priceWithDiscount: {
      type: ['number', 'null'],
    },
    taxValue: {
      type: ['number', 'null'],
    },
    priceWithTax: {
      type: ['number', 'null'],
    },
    description: {
      type: ['string', 'null'],
    },
    discountType: {
      type: ['string', 'null'],
    },
    discountAmount: {
      type: ['number', 'null'],
    },
    items: {
      type: 'array',
      nullable: true,
      items: {
        type: 'object',
        required: ['order', 'qty', 'amount'],
        properties: {
          order: {
            type: 'number',
          },
          description: {
            type: ['string', 'null'],
          },
          qty: {
            type: 'number',
          },
          amount: {
            type: 'number',
          },
        },
      },
      default: [],
    },
    settings: {
      type: 'object',
      nullable: true,
      properties: proposalSettingsSchema.properties,
      required: proposalSettingsSchema.required,
    },
    status: {
      type: 'string',
      enum: ['PENDING_PAYMENT', 'PARTIALLY_PAID', 'FULLY_PAID'],
    },
    createdAt: {
      type: ['number', 'null'],
    },
    updatedAt: {
      type: ['number', 'null'],
    },
    dueDate: {
      type: ['number', 'null'],
    },
    createdBy: {
      type: ['string', 'null'],
    },
    updatedBy: {
      type: ['string', 'null'],
    },
    priceProposalOverrideFields: {
      type: 'boolean',
    },
    priceProposalOverrideSettings: {
      type: 'boolean',
    },
    reviewRequiredAt: {
      type: ['number', 'null'],
    },
    paidStatusSource: {
      type: 'string',
    },
    totalPaid: {
      type: 'number',
    },
    balanceDue: {
      type: ['number', 'null'],
    },
  },
  indexes: ['workspaceId'],
};
